<div class="navbar-container">
    <p-megamenu class="app-menubar" [model]="menuItems">
        <ng-template #start>
            <a routerLink="/">
                <img [src]="logoPath" alt="Orange Logo" width="50" height="50" class="orange-logo" />
            </a>
        </ng-template>

        <ng-template #end>
            <!-- thin separator -->
            <span class="header-sep" aria-hidden="true">|</span>

            @if (currentUser) {
                <button class="user-panel-btn" type="button" (click)="userMenu?.toggle($event)">
                    <p-avatar styleClass="me-2" icon="pi pi-user" shape="circle"></p-avatar>
                    <span class="user-meta">
                        <span class="user-name"
                            >{{ currentUser.firstname | titlecase }} {{ currentUser.lastname | uppercase }}</span
                        >
                        <!-- todo Replace it with user role -->
                        <span class="user-role">Collaborative PM Role</span>
                    </span>
                </button>
            }
            <p-menu #userMenu [model]="userMenuItems" [popup]="true"></p-menu>
        </ng-template>
    </p-megamenu>

    <p-breadcrumb class="app-breadcrumb" [model]="breadcrumbs"></p-breadcrumb>
</div>
